<script>
  import { nextInkAug, nextInkSeed } from '../../lib/ink.js';

  // aug: inkpunk-ui shape mixins for the corners/edges (vendor/inkpunk-ui);
  // defaults to a rotating corner treatment so a page of cards doesn't repeat.
  // Pass aug={null} to keep the rectangle. Avoid the "border"/"inlay" mixins
  // here — .card already uses ::before/::after for its stamped frame.
  let { title = null, aug = undefined, children } = $props();

  const augValue = aug === undefined ? nextInkAug() : aug;
  const seed = nextInkSeed();
</script>

<div class="card" data-augmented-ui={augValue} data-ink-seed={augValue ? seed : null}>
  {#if title}
    <h2 class="text-hierarchy-3 mb-4">{title}</h2>
  {/if}
  {@render children?.()}
</div>
